import React from 'react';
import Box from '@mui/material/Box';
import PacmanLoader from 'react-spinners/PacmanLoader';

type PacmanLoaderProps = { loading: boolean };

export const PacmanLoaderBlock = ({ loading }: PacmanLoaderProps) => (
  <Box
    style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', zIndex: 3000, left: 0, top: 0 }}
    sx={{
      position: 'fixed',
      width: '100%',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <PacmanLoader loading={loading} color='#6414db' />
  </Box>
);
